import { Link } from 'react-router';
import cn from 'classnames';

import css from 'styles/components/landing/melodyCurated.scss';
import { setInlineBackgroundColor, setInlineTextColor } from 'helpers/LandingPageUtils';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import { stripSpecialChars } from 'helpers';

const MelodyCurated = ({ slotName, slotDetails, onLandingComponentClick, slotHeartsData }) => {
  const { products, title, link, ctacopy, copy, bgcolor, gae, textcolor, flip, monetateId } = slotDetails;

  const makeTitle = () => title && <figcaption style={setInlineTextColor(textcolor)}>{title}</figcaption>;

  const makeCopy = () => copy && <p style={setInlineTextColor(textcolor)}>{copy}</p>;

  const makeCallToAction = () => ctacopy && <button>{ctacopy}</button>;

  const makeMainContent = () => {
    const styling = (textcolor === 'white') ? css.mainContentCtaWhite : css.mainContentCtaDefault;
    return (
      <figure className={styling} style={setInlineBackgroundColor(bgcolor)}>
        <Link
          to={link}
          onClick={onLandingComponentClick}
          data-eventlabel="melodyCurated"
          data-eventvalue={ gae || title }>
          {makeTitle()}
          {makeCopy()}
          {makeCallToAction()}
        </Link>
      </figure>
    );
  };

  return (
    <div className={cn(css.mCurated, { [css.flipped]: flip === 'true' })} data-slot-id={slotName} data-monetate-id={monetateId}>
      {makeMainContent()}
      {products.map((product, i) => {
        const { msaImageUrl, thumbnailImageUrl, src } = product;
        return <MelodyCardProduct
          key={`${stripSpecialChars(msaImageUrl || thumbnailImageUrl || src)}_${i}`}
          cardData={product}
          componentStyle="melodyCurated"
          eventLabel="melodyCurated"
          onComponentClick={onLandingComponentClick}
          heartsData={slotHeartsData} />;
      })}
    </div>
  );
};

export default MelodyCurated;
